var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"block_cont",class:{ 'is-loop': _vm.isLoop }},[_c('FlowTreeActionBlock',_vm._g(_vm._b({staticClass:"action-block-wrapper"},'FlowTreeActionBlock',_vm.props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }